import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivitiesServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { forkJoin, ReplaySubject, Subject } from '@node_modules/rxjs';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { takeUntil } from '@node_modules/rxjs/operators';

@Component({
    selector: 'staff-table-filter',
    templateUrl: './staff-table-filter.component.html',
    styleUrls: ['./staff-table-filter.component.scss']
})
export class StaffTableFilterComponent extends AppComponentBase implements OnInit {
    filterText;

    staffRoles: any[];
    companies;

    constructor(
        injector: Injector,
        private _activitiesServiceProxy: ActivitiesServiceProxy,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
    }
    @Output() onFiltersChange: EventEmitter<any> = new EventEmitter<any>();

    public staffRoleFormCtrl: FormControl = new FormControl();
    public staffRoleFilterFormCtrl: FormControl = new FormControl();
    public filteredStaffRole: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    public companyFormCtrl: FormControl = new FormControl();
    public companyFilterFormCtrl: FormControl = new FormControl();
    public filteredCompany: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  


    protected _onDestroy = new Subject<void>();

    ngOnInit(): void {
        const editData = forkJoin({
            staffRoles: this._activitiesServiceProxy.getStaffRoles(),
            companies: this._activitiesServiceProxy.getStaffCompanies(),
            jobTitles: this._activitiesServiceProxy.getStaffJobTitles()
        });
        editData.subscribe((data) => {
            this.filteredStaffRole.next(data.staffRoles.slice());
            this.filteredCompany.next(data.companies.slice());

            this.staffRoles = data.staffRoles;
            this.companies = data.companies;
        });
        this.initiateFiltersValueChanges();
    }
    private initiateFiltersValueChanges() {
        this.staffRoleFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterStaffRoles();
            });

        this.companyFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterCompanies();
            });
    }
    refresh() {
        this.filtersChange();
    }
    clear() {
        this.filterText = null;
        this.staffRoleFormCtrl.reset();
        this.companyFormCtrl.reset();
        this.filtersChange();
    }
    filtersChange() {

        const params = {
            filterText: this.filterText || null,
            staffRole: this.staffRoleFormCtrl.value != null 
                        ? (this.staffRoleFormCtrl.value.staffRoleId != null  
                            ? this.staffRoleFormCtrl.value.staffRoleId 
                            : null) 
                        : null,
            company: this.companyFormCtrl.value || null,
        };

        this.onFiltersChange.emit(params);
    }


    protected filterStaffRoles() {
        if (!this.staffRoles) {
            return;
        }

        let search = this.staffRoleFilterFormCtrl.value;
        if (!search) {
            this.filteredStaffRole.next(this.staffRoles.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredStaffRole.next(
            this.staffRoles?.filter(
                (staffRole) => staffRole.staffRoleName.toLowerCase().indexOf(search) > -1
            )
        );
    }

    protected filterCompanies() {
        if (!this.companies) {
            return;
        }

        let search = this.companyFilterFormCtrl.value;
        if (!search) {
            this.filteredCompany.next(this.companies.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredCompany.next(
            this.companies?.filter(
                (company) => company.company.toLowerCase().indexOf(search) > -1
            )
        );
    }
}
